



import { defineAsyncComponent, defineComponent } from '@nuxtjs/composition-api';
import { gql } from 'graphql-tag';

import { contentableBlockColorFragment } from '@/composables/block-color';

import { medium1x1ImageFragment } from '@/graphql/queries/image.fragments';

export default defineComponent({
  components: {
    Page: defineAsyncComponent(() => import('@/pages/workers/_slug.vue')),
  },
  graphqlData: gql`
    fragment ScenkonstStaffContentData on ScenkonstStaffContent {
      id
      firstName
      lastName
      pageUrl
      parentPageUrl
      description
      performances{
        title
        subtitle
        pageUrl
        image{
          ...Medium1x1ImageData,
        }
        startDate
        endDate
      }
      category{
        id
        name
      }
      image {
        ...Medium1x1ImageData,
      }
      blocks {
        __typename @inject
      }
      ...ContentableBlockColor
    }

    ${medium1x1ImageFragment}
    ${contentableBlockColorFragment}
  `,
});
